import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import {
  Button,
  Card,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControlLabel,
  Switch,
  TablePagination,
} from "@material-ui/core";
import {
  agendaLimpiar,
  cancelarTurno,
  confirmarBajaTurnos,
  fetchContadoresAfiliado,
  fetchTurnosCanceladosPorAfiliado,
  fetchTurnosPorAfiliado,
} from "../../../actions/turnos/agenda";
import { ContadoresAfiliado } from "./ContadoresAfiliado";
import { fetchMotivosBajaTurno } from "../../../actions/turnos/motivosBajaTurno";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import ModalCredenciales from "../../compartidos/ModalCredenciales";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { TURNOS_PERMISOS } from "../../../utils/permisos";
import { postExentarTurno } from "../../../actions/coseguros/coseguros";
import { ListaCtaCte } from "./ListaCtaCte";
import { ModalDetalleComprobante } from "./ModalDetalleComprobante";
import { getTurnosCtaCte } from "../../../actions/turnos/ctaCte";
import { ModalPagoTurno } from "./ModalPagoTurno";
import { OBRAS_SOCIALES } from "../../../utils/constants";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const ListaTurnos = (props) => {
  const dispatch = useDispatch();
  const [openQuestion, setOpenQuestion] = useState(false);
  const [openQuestionExentarPago, setOpenQuestionExentarPago] = useState(false);
  const [turnoSelec, setTurnoSelec] = useState();
  const [idMotivoCancelacion, setIdMotivoCancelacion] = useState();
  const [openCredenciales, setOpenCredenciales] = React.useState(false);

  const [displayListaCtaCte, setDisplayListaCtaCte] = useState(false);
  const [displayDetalleComprobante, setDisplayDetalleComprobante] =
    useState(false);
  const [displayModalPagoTurno, setDisplayModalPagoTurno] = useState(false);
  const [pagoACuenta, setPagoACuenta] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);

  const { items } = useSelector((state) => state.agenda);
  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { items: motivosBajaItems, cargada: motivosBajaCargados } = useSelector(
    (state) => state.motivosBajaTurno
  );
  const { consultaAfiliado } = useSelector((state) => state.afiliacion);
  const { turnos } = useSelector((state) => state.ctaCte);

  const { idObraSocial } = props;

  useEffect(() => {
    dispatch(agendaLimpiar());
    dispatch(fetchContadoresAfiliado(consultaAfiliado.id_afiliado, consultaAfiliado.nro_doc, idObraSocial));
    dispatch(fetchTurnosPorAfiliado(consultaAfiliado.id_afiliado, consultaAfiliado.nro_doc, idObraSocial));
  }, [dispatch, consultaAfiliado.id_afiliado, idObraSocial]);

  useEffect(() => {
    if (!motivosBajaCargados) {
      dispatch(fetchMotivosBajaTurno());
    }
  }, [dispatch, motivosBajaCargados]);

  useEffect(() => {
    setTotal(turnos.map((turno) => turno.saldo).reduce((a, b) => a + b, 0));
  }, [items, turnos]);

  // useEffect(() => {
  //   dispatch(getTurnosCtaCte(consultaAfiliado?.id_afiliado));
  // }, [dispatch, consultaAfiliado?.id_afiliado]);

  const handleChangePage = (e, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleOpenCancelarTurno = (turno) => {
    setTurnoSelec(turno);
    setOpenQuestion(true);
  };

  const closeModalPagoHandler = () => {
    setDisplayModalPagoTurno(false);
  };

  const handleSendCancelarTurno = () => {
    if (turnoSelec.sobreTurno)
      dispatch(confirmarBajaTurnos([turnoSelec.idAgenda], idMotivoCancelacion));
    else dispatch(cancelarTurno(turnoSelec.idAgenda, idMotivoCancelacion));
    resetValues();
    setOpenQuestion(false);
  };

  const handleCloseAlert = () => {
    resetValues();
    setOpenQuestion(false);
  };

  const handleInputChangeMotivo = ({ target }) => {
    setIdMotivoCancelacion(target.value);
  };

  const handleOpenExentarPagoTurno = (turno) => {
    setTurnoSelec(turno);
    setOpenQuestionExentarPago(true);
  };

  const handleCloseAlertExentarPagoTurno = () => {
    resetValues();
    setOpenQuestionExentarPago(false);
  };

  const handleSendExentarPagoTurno = () => {
    dispatch(postExentarTurno(turnoSelec.idAgenda, turnoSelec.idAfiliado));
    resetValues();
    setOpenQuestionExentarPago(false);
  };

  const resetValues = () => {
    setTurnoSelec();
    setIdMotivoCancelacion();
  };
  if (items?.length > 0) {
    items.sort((c, d) => new Date(d.fecha) - new Date(c.fecha));
  }
  const traerPorTipo = (tipo) => {
    switch (tipo) {
      case 1:
        dispatch(fetchTurnosPorAfiliado(consultaAfiliado.id_afiliado, consultaAfiliado.nro_doc, idObraSocial));
        break;
      case 2:
        dispatch(fetchTurnosPorAfiliado(consultaAfiliado.id_afiliado, consultaAfiliado.nro_doc, idObraSocial, 2));
        break;
      case 3:
        dispatch(
          fetchTurnosCanceladosPorAfiliado(consultaAfiliado.id_afiliado, consultaAfiliado.nro_doc, idObraSocial)
        );
        break;
      case 4:
        dispatch(fetchTurnosPorAfiliado(consultaAfiliado.id_afiliado, consultaAfiliado.nro_doc, idObraSocial, 4));
        break;
      default:
        break;
    }
  };

  const permisoAdmin = validarSoloUnPermiso(
    permisosUser,
    TURNOS_PERMISOS.PERMITE_CANCELAR_ASISTENCIA_SIN_MIRAR_FECHA
  )

  return (
    <React.Fragment>
      <ModalDetalleComprobante
        open={displayDetalleComprobante}
        handleClose={() => setDisplayDetalleComprobante(false)}
      />
      <ModalPagoTurno
        pagoACuenta={pagoACuenta}
        open={displayModalPagoTurno}
        closeModalHandler={closeModalPagoHandler}
        idGrupoFamiliar={consultaAfiliado?.idGrupoFamiliar}
        usuarioTurnoSeleccionado={{
          ...turnoSelec,
          idAfiliado: consultaAfiliado?.id_afiliado,
        }}
      />
      <Grid
        container
        justify="center"
        style={{
          alignItems: "center",
          alignContent: "space-evenly",
          marginTop: "1rem",
        }}
      >
        <Grid item xs={12} sm={4} md={8}>
          <Card>
            <ContadoresAfiliado
              traerPorTipo={traerPorTipo}
              setDisplayListaCtaCte={setDisplayListaCtaCte}
            />
          </Card>
        </Grid>
        <Button
          color="primary"
          variant="contained"
          style={{ width: "10rem", marginLeft: "3rem" }}
          onClick={() => {
            dispatch(
              getTurnosCtaCte(
                consultaAfiliado?.id_afiliado, consultaAfiliado?.nro_doc, idObraSocial, setDisplayListaCtaCte(true))
            );
          }}
        >
          CTA CTE
          <br /> {idObraSocial === OBRAS_SOCIALES.OSPEDYC ? 'GRUPO FAMILIAR' : 'AFILIADO'}
        </Button>
      </Grid>
      <Grid container justify="center" style={{ marginTop: "1rem" }}>
        <Grid item xs={12} sm={10} md={11} style={{ marginTop: 15 }}>
          <Card>
            <TableContainer component={Paper}>
              {displayListaCtaCte ? (
                <ListaCtaCte
                  setDisplayDetalleComprobante={setDisplayDetalleComprobante}
                  setDisplayModalPagoTurno={setDisplayModalPagoTurno}
                  idAfiliado={consultaAfiliado?.id_afiliado}
                  nroDocumento={consultaAfiliado?.nro_doc}
                  setPagoACuenta={setPagoACuenta}
                  setTurnoSelec={setTurnoSelec}
                  idObraSocial={idObraSocial}
                  rowsPerPage={rowsPerPage}
                  turnos={turnos}
                  total={total}
                  dense={dense}
                  page={page}
                />
              ) : (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Fecha</TableCell>
                      <TableCell align="left">Hora</TableCell>
                      <TableCell align="left">Sobre Turno</TableCell>
                      <TableCell align="left">Centro Médico</TableCell>
                      <TableCell align="left">Profesional</TableCell>
                      <TableCell align="left">Especialidad</TableCell>
                      <TableCell align="left">Modalidad</TableCell>
                      {permisoAdmin &&
                        <TableCell align="left">Otorgado por</TableCell>
                      }
                      <TableCell align="left"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.length > 0 ? (
                      items.map((item) => (
                        <TableRow key={item.idAgenda}>
                          <TableCell align="left">
                            {new Date(item.fecha).toLocaleString(
                              "es",
                              optionsfecha
                            )}
                          </TableCell>
                          <TableCell align="left">{item.hora}</TableCell>
                          <TableCell align="left">
                            {item.sobreTurno ? "Si" : "No"}
                          </TableCell>
                          <TableCell align="left">
                            {item.centroMedico?.descripcionCentro}
                          </TableCell>
                          <TableCell align="left">
                            {item.efectorRed?.nombreEfector}
                          </TableCell>
                          <TableCell align="left">
                            {item.especialidad?.descripcionEspecialidades}
                          </TableCell>
                          <TableCell align="left">
                            {item.idTipoTurnoSol === 1
                              ? "Presencial"
                              : "Virtual"}
                          </TableCell>
                          {permisoAdmin &&
                            <TableCell align="left">
                              {item?.usuario?.userName
                                ? item?.usuario?.userName
                                : "Afiliado"}
                            </TableCell>
                          }
                          <TableCell align="left">
                            <Button
                              variant="contained"
                              style={{ minWidth: 140 }}
                              onClick={() => handleOpenCancelarTurno(item)}
                              disabled={
                                item.confirmado ||
                                moment(item.fecha).isBefore(moment(), "day") ||
                                item.idMotivoBajaTurno ||
                                !validarSoloUnPermiso(
                                  permisosUser,
                                  TURNOS_PERMISOS.CANCELAR
                                )
                              }
                              color="primary"
                            >
                              Cancelar
                            </Button>
                            {!item.exencion &&
                              !item.confirmado &&
                              idObraSocial === OBRAS_SOCIALES.OSPEDYC &&
                              moment(item.fecha).isSame(moment(), "day") &&
                              !item.idMotivoBajaTurno &&
                              validarSoloUnPermiso(
                                permisosUser,
                                TURNOS_PERMISOS.EXENTAR_PAGO_TURNO
                              ) && (
                                <Button
                                  variant="contained"
                                  style={{ minWidth: 140, marginLeft: 20 }}
                                  onClick={() =>
                                    handleOpenExentarPagoTurno(item)
                                  }
                                >
                                  Exentar pago
                                </Button>
                              )}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow style={{ height: 50 }}>
                        <TableCell
                          colSpan={8}
                          style={{ textAlign: "-webkit-center" }}
                        >
                          {" "}
                          Sin Registros
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
            {displayListaCtaCte && (
              <React.Fragment>
                <TablePagination
                  style={{ backgroundColor: "white" }}
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={turnos.length}
                  rowsPerPage={rowsPerPage}
                  labelRowsPerPage="Registros por página"
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={dense}
                      onChange={(e) => setDense(e.target.checked)}
                    />
                  }
                  label="Tamaño compacto"
                />
              </React.Fragment>
            )}
          </Card>
          {!displayListaCtaCte && idObraSocial === OBRAS_SOCIALES.OSPEDYC && (
            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              <Button
                variant="contained"
                color="default"
                size="small"
                onClick={() => {
                  setOpenCredenciales(true);
                }}
                startIcon={<CreditCardIcon />}
              >
                VER CREDENCIALES
              </Button>
            </div>
          )}
        </Grid>
        {openQuestion && (
          <AlertFinalizadoStepper
            open={openQuestion}
            pregunta={"Cancelación de Turno"}
            dialogText={"Quiere proceder con la Cancelación del Turno?"}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Continuar"}
            showComboDialog={true}
            itemsCombo={motivosBajaItems}
            idCombo={"idMotivoBajaTurno"}
            labelCombo={"Motivo"}
            manejadorInputChange={handleInputChangeMotivo}
            valor={idMotivoCancelacion}
            handleClose={handleCloseAlert}
            handleSend={handleSendCancelarTurno}
          />
        )}
        {openQuestionExentarPago && (
          <AlertFinalizadoStepper
            open={openQuestionExentarPago}
            pregunta={`Exentar pago de turno`}
            dialogText={`Quiere proceder con la exención del pago del turno?`}
            buttonCancel={"Cancelar"}
            buttonSubmit={"Confirmar"}
            handleClose={handleCloseAlertExentarPagoTurno}
            handleSend={handleSendExentarPagoTurno}
          />
        )}
        <ModalCredenciales
          open={openCredenciales}
          setOpen={setOpenCredenciales}
          idObraSocial={idObraSocial}
        />
      </Grid>
    </React.Fragment>
  );
};
